var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRigthArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48438 6.33973C7.48438 6.12838 7.40367 5.91698 7.24264 5.75579L2.17012 0.683409C1.84745 0.360739 1.3243 0.360739 1.00176 0.683409C0.679222 1.00595 0.679222 1.529 1.00176 1.85169L5.49013 6.33973L1.00207 10.8279C0.679535 11.1505 0.679535 11.6736 1.00207 11.9961C1.32461 12.3189 1.84761 12.3189 2.17028 11.9961L7.24282 6.92382C7.40383 6.76255 7.48438 6.55115 7.48438 6.33973Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigthArrow);
export default __webpack_public_path__ + "static/media/RigthArrow.bc82e55d2b2f9658129ca3c80cff5ba8.svg";
export { ForwardRef as ReactComponent };